/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_Sales_DescInputs */

const en_mk_mock_agent_sales_desc = /** @type {(inputs: Mk_Mock_Agent_Sales_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast replies, lead recaps, follow-up notes.`)
};

const id_mk_mock_agent_sales_desc = /** @type {(inputs: Mk_Mock_Agent_Sales_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan cepat, rekap prospek, notulen follow-up.`)
};

/**
* | output |
* | --- |
* | "Fast replies, lead recaps, follow-up notes." |
*
* @param {Mk_Mock_Agent_Sales_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_sales_desc = /** @type {((inputs?: Mk_Mock_Agent_Sales_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_Sales_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_sales_desc(inputs)
	return en_mk_mock_agent_sales_desc(inputs)
});